<template>
  <div>
    <div v-loading="!loaded">
      <el-row class="toolbar">
        <el-col :span="2">
          <el-button
            type="success"
            @click="routesFirst = !routesFirst"
            plain
            :title="
              routesFirst ? 'Display bushes and routes' : 'Display only routes'
            "
          >
            <fa icon="bus" v-show="routesFirst" fixed-width size="lg"></fa>
            <fa icon="route" fixed-width size="lg"></fa>
          </el-button>
        </el-col>
        <el-col :span="2">
          <el-date-picker
            v-if="selectDate"
            style="width: 100%"
            v-model="workingDate"
            :picker-options="{ firstDayOfWeek: 1 }"
            value-format="d/M/yyyy"
            format="dd/MM/yyyy"
            type="date"
            @change="loadData()"
            placeholder="Pick a day"
          ></el-date-picker>
          <el-button
            v-else
            type="info"
            plain
            @click="selectDate = true"
            size="mini"
            style="font-size: 11px; height: 36px"
          >
            <i class="material-icons">access_alarm</i>
            <strong :key="clock">{{
              workingDate ? workingDate : timeNow
            }}</strong>
          </el-button>
        </el-col>
        <el-col :span="20">
          <el-row
            class="selectedElement"
            v-if="selectedRoute && selectedRoute.id"
          >
            <el-col :span="2">
              <el-button
                type="warning"
                icon="el-icon-close"
                circle
                size="mini"
                @click="selectedRoute = {}"
              ></el-button>
            </el-col>
            <el-col :span="22">
              <drag
                :key="selectedRoute.id"
                :transfer-data="{ rid: selectedRoute.id }"
              >
                <routing-route
                  :routeData="selectedRoute"
                  previewMode
                  class="drag"
                ></routing-route>
              </drag>
            </el-col>
          </el-row>
          <el-row
            class="selectedElement"
            v-if="!selectedRoute.id && selectedVehicle && selectedVehicle.id"
          >
            <el-col :span="2">
              <el-button
                type="warning"
                icon="el-icon-close"
                size="mini"
                circle
                @click="selectedVehicle = {}"
              ></el-button>
            </el-col>
            <el-col :span="18">
              <drag class="drag" :transfer-data="{ vid: selectedVehicle.id }">
                <routing-vehicle
                  :vehicle-data="selectedVehicle"
                ></routing-vehicle>
              </drag>
            </el-col>
            <el-col :span="4">
              <el-button
                type="warning"
                icon="el-icon-message"
                size="mini"
                :disabled="!selectedDriver"
                outline
                @click="
                  messagesTo = { id: selectedVehicle.drivers[0] };
                  messageDrawer = true;
                "
                >{{ selectedDriver }}</el-button
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row>
        <transition name="el-fade-in-linear">
          <el-col
            :span="routesFirst ? 24 : 9"
            :class="'routing-slot ' + popVehiclesState"
            v-show="!routesFirst || selectedRoute.id"
          >
            <s-toolbar>
              <el-checkbox
                border
                v-model="activationEnabled"
                title="Activate/Diactivate vehicles"
                slot="left"
              >
                <fa icon="bus"></fa>
              </el-checkbox>
              <el-autocomplete
                :fetch-suggestions="queryVehicles"
                ref="chooseVehicle"
                placeholder="Βρες το οχημα"
                slot="center"
                style="width: 100%"
                v-model="gotoVehicle"
                clearable
                value-key="name"
                @select="handleSelectVehicle"
              >
                <template slot-scope="{ item }">
                  <div :class="item.active ? 'active' : 'freezed'">
                    <span class="title">{{ item.name }}</span>
                    <template v-if="item.nowis">
                      <span class="el-badge__content el-badge__content">{{
                        item.nowis.resort
                      }}</span>

                      <!-- <span>{{vehicle.nowis.ppname}}</span> -->
                      <i
                        class="material-icons small"
                        v-if="item.nowis.status == 'MOVING'"
                        >fast_forward</i
                      >
                      <i
                        class="material-icons small"
                        v-if="item.nowis.status == 'OFFLINE'"
                        >signal_wifi_off</i
                      >
                      <span v-if="item.nowis.status == 'STOPED'">
                        <i class="material-icons small">stop</i>
                      </span>
                    </template>
                    <span class="info">
                      <i class="el-icon-sort"></i>
                      {{ item.transits.avg_diff }}
                    </span>
                  </div>
                </template>
              </el-autocomplete>
              <el-button
                slot="center"
                type="warning"
                icon="el-icon-close"
                circle
                size="mini"
                @click="selectedRoute = {}"
                v-if="routesFirst && selectedRoute && selectedRoute.id"
              ></el-button>

              <el-checkbox-group
                v-model="displayVehicleTypes"
                size="mini"
                slot="right"
              >
                <el-checkbox-button :key="'mini'" :label="'mini'" title="mini">
                  <fa :icon="icon('mini')"></fa>
                </el-checkbox-button>
                <el-checkbox-button
                  :key="'medium'"
                  :label="'medium'"
                  title="medium"
                >
                  <fa :icon="icon('medium')"></fa>
                </el-checkbox-button>
                <el-checkbox-button
                  :key="'normal'"
                  :label="'normal'"
                  title="normal"
                >
                  <fa :icon="icon('normal')"></fa>
                </el-checkbox-button>
                <el-checkbox-button :key="'big'" :label="'big'" title="big">
                  <fa :icon="icon('big')"></fa>
                </el-checkbox-button>
                <el-checkbox-button
                  :key="'double'"
                  :label="'double'"
                  title="double"
                >
                  <fa :icon="icon('double')"></fa>
                </el-checkbox-button>
              </el-checkbox-group>
            </s-toolbar>

            <el-row id="vehiclesC" v-loading="processingVehicles">
              <el-col :span="9">
                <div style="height: calc(50vh - 90px); overflow: auto">
                  <el-row
                    v-for="vv in airportBigVehicles"
                    :key="vv.id"
                    :id="vv.name"
                    :class="{
                      'vehicle-slot': true,
                      vstopped: vv.nowis.status == 'STOPED',
                      rselected: vv.id == selectedVehicle.id,
                      levelC: vv.weight.hard > 0,
                      levelA: vv.weight.soft < 0,
                      levelB: vv.weight.soft > 0,
                    }"
                  >
                    <el-col
                      :span="activationEnabled ? 1 : 0"
                      style="background: #009688"
                    >
                      <el-checkbox
                        v-model="vv.active"
                        @input="
                          rememberIt('vehicle_active_' + vv.id, vv.active)
                        "
                      ></el-checkbox>
                    </el-col>
                    <el-col :span="activationEnabled ? 23 : 24">
                      <drop class="drop" @drop="(e) => assignRoute(e, vv.id)">
                        <drag class="drag" :transfer-data="{ vid: vv.id }">
                          <div @click="handleSelectVehicle(vv)">
                            <routing-vehicle
                              hide-info
                              @viewVehicle="
                                focusOnVehicle = vv.id;
                                selectedVehicle = {};
                              "
                              :vehicle-data="vv"
                            ></routing-vehicle>
                          </div>
                        </drag>
                      </drop>
                    </el-col>
                  </el-row>
                </div>
                <div style="height: calc(50vh - 90px); overflow: auto">
                  <el-row
                    v-for="vv in airportSmallVehicles"
                    :key="vv.id"
                    :id="vv.name"
                    x-class="{'vehicle-slot':true,vstopped:(vv.nowis.status=='STOPED') ,rselected:(vv.id==selectedVehicle.id),'levelC':(vv.weight.hard>0),'levelA':(vv.weight.soft<0),'levelB':(vv.weight.soft>0)}"
                  >
                    <el-col
                      :span="activationEnabled ? 1 : 0"
                      style="background: #009688"
                    >
                      <el-checkbox
                        v-model="vv.active"
                        @input="
                          rememberIt('vehicle_active_' + vv.id, vv.active)
                        "
                      ></el-checkbox>
                    </el-col>
                    <el-col :span="activationEnabled ? 23 : 24">
                      <drop class="drop" @drop="(e) => assignRoute(e, vv.id)">
                        <drag class="drag" :transfer-data="{ vid: vv.id }">
                          <div @click="handleSelectVehicle(vv)">
                            <routing-vehicle
                              hide-info
                              @viewVehicle="
                                focusOnVehicle = vv.id;
                                selectedVehicle = {};
                              "
                              :vehicle-data="vv"
                            ></routing-vehicle>
                          </div>
                        </drag>
                      </drop>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col
                :span="15"
                style="height: calc(100vh - 180px); overflow: auto"
              >
                <el-row
                  v-for="vv in goodVehicles"
                  :key="vv.id"
                  :id="vv.name"
                  :class="{
                    'vehicle-slot': true,
                    vstopped: vv.nowis.status == 'STOPED',
                    rselected: vv.id == selectedVehicle.id,
                    levelC: vv.weight.hard > 0,
                    levelA: vv.weight.soft < 0,
                    levelB: vv.weight.soft > 0,
                  }"
                >
                  <el-col
                    :span="activationEnabled ? 1 : 0"
                    style="background: #009688"
                  >
                    <el-checkbox
                      v-model="vv.active"
                      @input="rememberIt('vehicle_active_' + vv.id, vv.active)"
                    ></el-checkbox>
                  </el-col>
                  <el-col :span="activationEnabled ? 23 : 24">
                    <drop class="drop" @drop="(e) => assignRoute(e, vv.id)">
                      <drag class="drag" :transfer-data="{ vid: vv.id }">
                        <div @click="handleSelectVehicle(vv)">
                          <routing-vehicle
                            @viewVehicle="
                              focusOnVehicle = vv.id;
                              selectedVehicle = {};
                            "
                            :vehicle-data="vv"
                          ></routing-vehicle>
                        </div>
                      </drag>
                    </drop>
                  </el-col>
                </el-row>
              </el-col>
              <!-- </transition-group> -->
            </el-row>
          </el-col>
        </transition>
        <el-col :span="routesFirst ? 24 : 15" class="routing-slot">
          <s-toolbar>
            <el-checkbox-group
              v-model="displayRouteTypes"
              size="mini"
              slot="left"
            >
              <el-checkbox-button :key="'ARV'" :label="'ARV'">
                <fa title="ARIVALS" icon="plane-arrival"></fa>
              </el-checkbox-button>
              <el-checkbox-button :key="'DEP'" :label="'DEP'">
                <fa title="DEPARTURES" icon="plane-departure"></fa>
              </el-checkbox-button>
              <el-checkbox-button :key="'PICKUP'" :label="'PICKUP'">
                <fa title="PICKUPS" icon="walking"></fa>
              </el-checkbox-button>
              <el-checkbox-button :key="'EXCRS'" :label="'EXCRS'">
                <fa title="EXCURSIONS" icon="ship"></fa>
              </el-checkbox-button>
            </el-checkbox-group>

            <el-checkbox-group
              v-model="tripExecStatus"
              size="mini"
              slot="center"
              :disabled="vehicleTypesOnRoutes.indexOf('internal') < 0"
            >
              <el-checkbox-button :key="'notyet'" :label="'notyet'">
                <fa title="GOING" icon="angle-double-right"></fa>
              </el-checkbox-button>
              <el-checkbox-button :key="'maybe'" :label="'maybe'">
                <fa title="MAYBE DONE" icon="calendar-check"></fa>
              </el-checkbox-button>
              <el-checkbox-button :key="'sure'" :label="'sure'">
                <fa title="DONE" icon="check-square"></fa>
              </el-checkbox-button>
              <!-- <el-checkbox-button :key="'NOVEHICEL'" :label="'EXCRS'">
                <fa title="EXCURSIONS" icon="ship"></fa>
              </el-checkbox-button>-->
            </el-checkbox-group>
            <span slot="center">&nbsp;</span>
            <el-checkbox-group
              v-model="vehicleTypesOnRoutes"
              size="mini"
              slot="center"
            >
              <el-checkbox-button :key="'internal'" :label="'internal'">
                <fa title="Routes on companies Vehicles" icon="bus"></fa>
              </el-checkbox-button>
              <el-checkbox-button :key="'external'" :label="'external'">
                <fa title="Routes on partners Vehicles" icon="taxi"></fa>
              </el-checkbox-button>
              <el-checkbox-button :key="'nobus'" :label="'nobus'">
                <fa
                  title="Routes that are not assigned"
                  icon="user-friends"
                ></fa>
              </el-checkbox-button>
            </el-checkbox-group>

            <el-button
              slot="right"
              type="warning"
              round
              @click="timePriority = !timePriority"
            >
              <fa title="sort by time" v-show="!timePriority" icon="clock"></fa>
              <fa
                v-show="timePriority"
                icon="map-marked"
                title="sort by state"
              ></fa>
            </el-button>
            <el-button
              slot="right"
              type="primary"
              round
              @click="
                resetRouteView();
                ++tickTok;
              "
            >
              <fa icon="sync"></fa>
            </el-button>
          </s-toolbar>

          <el-row>
            <el-col :span="1">
              <el-menu default-active="expired" class="el-menu-vertical-demo">
                <el-menu-item
                  index="expired"
                  @click="scrollLevelRoutes('levelA')"
                  v-if="!timePriority"
                >
                  <i class="material-icons">error</i>
                </el-menu-item>
                <el-menu-item
                  index="pending"
                  @click="scrollLevelRoutes('inFuture')"
                >
                  <i class="material-icons">slow_motion_video</i>
                </el-menu-item>
                <el-menu-item
                  index="nouse"
                  @click="scrollLevelRoutes('levelC')"
                  v-if="!timePriority"
                >
                  <i class="material-icons">subway</i>
                </el-menu-item>
              </el-menu>
            </el-col>
            <el-col
              :span="23"
              id="routesC"
              v-loading="processingRoutes"
              :key="tickTok"
              xstyle="height: calc(100vh - 180px); overflow: auto"
            >
              <q-virtual-scroll
                style="max-height: calc(100vh - 180px)"
                :items="bestRoutes"
                separator
              >
                <template v-slot="{ item, index }">
                  <!--  v-for="(rr, idx) in bestRoutes" -->
                  <div
                    :key="item.id"
                    @click="selectRoute(item)"
                    :id="'r' + index"
                    style="height: 30px"
                  >
                    <drop class="drop" @drop="(e) => assignVehicle(e, item)">
                      <drag class="drag" :transfer-data="{ rid: item.id }">
                        <routing-route
                          v-loading="item.changing"
                          :routeData="item"
                          @removeVehicle="removeVehicle"
                        ></routing-route>
                      </drag>
                    </drop>
                  </div>
                </template>
              </q-virtual-scroll>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-drawer
      title="I am the title"
      :visible.sync="messageDrawer"
      direction="rtl"
    >
      <message-list
        v-if="messageDrawer"
        :contactData="messagesTo"
      ></message-list>
    </el-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";
import RouterEngine from "~/api/router";
import q from "querystring";

import printHtml from "~/mixins/printHtml";
import MessageList from "../MESSAGING/MessageList.vue";

export default {
  components: { MessageList },
  mixins: [printHtml],
  data() {
    return {
      messageDrawer: false,
      messagesTo: null,
      tickTok: 0,
      pause: true,
      selectDate: false,
      routesFirst: false,
      gotoVehicle: null,
      activationEnabled: false,
      tripExecStatus: ["sure", "maybe", "notyet"],
      vehicleTypesOnRoutes: ["external", "internal", "nobus"],
      displayRouteTypes: ["ARV", "DEP", "PICKUP", "EXCRS"],
      displayVehicleTypes: ["mini", "medium", "normal", "big", "double"],
      timeNow: null,
      timePriority: true,
      processingRoutes: false,
      processingVehicles: false,
      clock: 0,
      printData: null,
      printReady: false,
      loaded: false,
      vehicles: [],
      // todayLocs:{},
      vrouter: null,
      focusOnVehicle: null,
      selectedVehicle: { id: 0 },
      selectedRoute: { id: 0 },
      routes: [],
      workingDate: null,
      bookingRangeR: [dateHelper.startOfToday(), dateHelper.endOfTomorrow()],

      filterVehicle: { byLoc: null, byName: null },

      todayDepartures: [],
      cols: {},
      dateFormat: "DD/MM/YYYY",

      emulatorCounter: 0,

      printoptions: {
        name: "_blank",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: ["/css/app.css"],
      },
    };
  },
  watch: {
    gotoVehicle(val, oldval) {
      var options = {
        container: "#vehiclesC",
        easing: "ease-in",
        offset: 0,
        force: true,
        // cancelable: true,
        onStart: function (element) {
          // scrolling started
        },
        onDone: function (element) {
          // scrolling is done
        },
        onCancel: function () {
          // scrolling has been interrupted
        },
        x: false,
        y: true,
      };
      var cc = document.getElementById("vehiclesC"),
        sloc = 3;

      var archors = cc.getElementsByClassName("vehicle-slot"); //querySelector(".level" + level)
      // var testA = document.querySelector(".level" + level+":first")
      // _log_("fss....", test);
      if (isNaN(val)) sloc = 0;
      var findArchor = null;
      if (!val || val == oldval) return;
      for (const key in archors) {
        if (archors.hasOwnProperty(key)) {
          const element = archors[key];

          if (
            element.getAttribute("id") &&
            element
              .getAttribute("id")
              .toUpperCase()
              .indexOf(val.toUpperCase()) === sloc
          ) {
            findArchor = element.getAttribute("id");

            _log_(
              "AAA fss...." + element.getAttribute("id"),
              element.getAttribute("id").indexOf(val),
              val,
              sloc
            );
            break;
          }
        }
      }
      if (findArchor)
        var cancelScroll = this.$scrollTo("#" + findArchor, 300, options);
      // if (archors && archors[0].id)
      //   var cancelScroll = this.$scrollTo("#" + archors[0].id, 300, options);
      // var cancelScroll = VueScrollTo.scrollTo(element, duration, options)

      // or alternatively inside your components you can use
      // var cancelScroll = this.$scrollTo(".level" + level, 300, options);
    },
    workingDate(val) {
      _log_("watch locs fss,", val);
    },
    // 'vrouter.usedLocs'(val){
    //   this.todayLocs=val
    //   _log_("watch locs fss,", val);
    // },
    displayRouteTypes(valFilters, oldval) {
      // _log_("fss,", valFilters);
      const vm = this;
      if (valFilters) {
        this.goFilterRoutes();
      }
      // _log_("fss....");
      // ++this.clock;
    },
    vehicleTypesOnRoutes(valFilters, oldval) {
      // _log_("fss,", valFilters);
      const vm = this;
      if (valFilters) {
        this.goFilterRoutes();
      }
      // _log_("fss....");
      // ++this.clock;
    },
    tripExecStatus(valFilters, oldval) {
      // _log_("fss,", valFilters);
      const vm = this;
      if (valFilters) {
        this.goFilterRoutes();
      }
      // _log_("fss....");
      // ++this.clock;
    },
    filterVehicle: {
      handler(valFilters, oldval) {
        _log_("fss,", valFilters);
        const vm = this;
        if (valFilters) {
          // this.processingRoutes = true;

          vm.goFilterVehicles();
          // this.processingRoutes = false;
        }
      },
      deep: true,
      // ++this.clock;
    },
    displayVehicleTypes(valFilters, oldval) {
      // _log_("fss,", valFilters);
      const vm = this;
      if (valFilters) {
        // this.processingRoutes = true;

        vm.goFilterVehicles();
        // this.processingRoutes = false;
      }

      // ++this.clock;
    },
  },
  methods: {
    handleSelectVehicle(e) {
      _log_("oooo,ooo...", e, this.selectedRoute);
      this.getLiveData(true);
      this.timePriority = false;
      if (this.selectedRoute.id) {
        this.assignVehicle(e, this.selectedRoute);
        this.selectedRoute = {};
        this.gotoVehicle = "";
      } else {
        this.focusOnVehicle = 0;
        this.selectedVehicle = e;
      }
      // var rs = this.vrouter.bestRoutes(this.selectedVehicle, this.timePriority);
    },
    queryVehicles(queryString, cb) {
      var r = null;
      _log_("oooo,queryString...", queryString);
      if (queryString)
        r = this.bestVehicles.filter(function (v) {
          if (v && v.name && v.name !== null)
            return v.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
          return false;
        });
      else r = this.bestVehicles;
      // var r = queryString
      //   ? this.bestVehicles
      //   : this.bestVehicles.filter(function(v) {
      //       return v.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
      //     });
      cb(r);
    },
    check(e) {
      _log_("oooo,ooo...", e);
    },
    resetRouteView() {
      this.tripExecStatus = ["sure", "maybe", "notyet"];
      this.vehicleTypesOnRoutes = ["external", "internal", "nobus"];
      this.displayRouteTypes = ["ARV", "DEP", "PICKUP", "EXCRS"];
      this.displayVehicleTypes = ["mini", "medium", "normal", "big", "double"];
      this.focusOnVehicle = null;
      this.selectedVehicle = {};
      // this.vrouter = new RouterEngine(
      //   this,
      //   legs.data.results,
      //   locs.data.results
      // );
      // this.vrouter.usedLocs=this.todayLocs

      this.vrouter.filters.routetypes = this.displayRouteTypes;
      this.loadData();
    },
    emulator() {
      return;
      // return;
      const vm = this;
      var sending = false;
      // const data = await api.fetchProcessor("waypoints/emulate", {
      //       limit: 1,
      //       start: 0
      //     });
      //     _log_("the EE", data);
      //   this.loaded = true;
      setInterval(async function () {
        if (sending) return;
        const { data } = await api.fetchProcessor("waypoints/emulate", {
          limit: 1,
          start: ++vm.emulatorCounter,
        });
        if (data)
          for (let index = 0; index < data.results.length; index++) {
            const r = await data.results[index];
            await vm.axios.post(
              "gpsgatechina.txt",
              q.stringify({
                forcedb: "ionian",
                y: r.lat,
                x: r.lng,
                asset: r.asset,
              })
            );
          }
        // data.results.forEach(r => {
        // await  vm.axios.post(
        //     "gpsgatechina.txt",
        //     q.stringify({
        //       forcedb: "ionian",
        //       y: r.lat,
        //       x: r.lng,
        //       asset: r.asset
        //     })
        //   );
        //   _log_("the EE", r);
        // });
      }, 1000);
    },
    goFilterVehicles() {
      const vm = this;
      // _log_('.....',vm.filterVehicle)
      if (this.vrouter)
        this.vrouter.setVehicles(
          this.vehicles.filter(function (r) {
            // _log_(
            //   "what?" + r.name,
            //   r,
            //   "??",
            //   vm.filterVehicle.byName +
            //     ">>" +
            //     (vm.filterVehicle.byName.indexOf(r.id + "") >= 0)
            // );
            var checkedLoc = false;
            if (vm.filterVehicle.byLoc && vm.filterVehicle.byLoc.length) {
              if (r.ended && r.ended.lastLoc) {
                if (vm.filterVehicle.byLoc.indexOf(r.ended.lastLoc + "") >= 0)
                  checkedLoc = true;
              }
              if (r.nowis && r.nowis.locid) {
                if (vm.filterVehicle.byLoc.indexOf(r.nowis.locid + "") >= 0)
                  checkedLoc = true;
              }
            } else checkedLoc = true;
            return (
              (r.type == "" || vm.displayVehicleTypes.indexOf(r.type) >= 0) &&
              (!vm.filterVehicle.byName ||
                !vm.filterVehicle.byName.length ||
                vm.filterVehicle.byName.indexOf(r.id + "") >= 0) &&
              checkedLoc
            );
          })
        );
    },
    goFilterRoutes() {
      const vm = this;
      if (this.vrouter)
        this.vrouter.setRoutes(
          this.routes.filter(function (r) {
            var goexec = false,
              gotype = false,
              govehicle = false;
            _log_("chl.R.", r);
            if (
              vm.tripExecStatus.length &&
              r.asset_id &&
              !vm.vrouter.externalVehicleIds[r.asset_id]
            ) {
              if (r.isDone && vm.tripExecStatus.indexOf(r.isDone) >= 0)
                goexec = true;
            } else goexec = true;
            if (!goexec) return false;
            if (vm.vehicleTypesOnRoutes.length) {
              if (
                r.asset_id &&
                vm.vehicleTypesOnRoutes.indexOf("external") >= 0 &&
                vm.vrouter.externalVehicleIds[r.asset_id]
              )
                govehicle = true;
              if (vm.vehicleTypesOnRoutes.indexOf("nobus") >= 0 && !r.asset_id)
                govehicle = true;
              if (
                r.asset_id &&
                vm.vehicleTypesOnRoutes.indexOf("internal") >= 0 &&
                !vm.vrouter.externalVehicleIds[r.asset_id]
              )
                govehicle = true;
            }
            if (!govehicle) return false;

            if (vm.displayRouteTypes.length) {
              // _log_("chl.R.", r.destination);
              if (vm.displayRouteTypes.indexOf(r.destination) >= 0) return true;
              // if (
              //   r.destination == "PICKUP" &&
              //   vm.displayRouteTypes.indexOf("PICKUP") >= 0
              // )
              //   return true;
              // if (
              //   r.destination == "EXCRS" &&
              //   vm.displayRouteTypes.indexOf("EXCRS") >= 0
              // )
              //   return true;
              // if (r.locseq) {
              //   if (
              //     r.locseq.indexOf(vm.vrouter.AIRPORT) === 0 &&
              //     vm.displayRouteTypes.indexOf("ARV") >= 0
              //   )
              //     return true;

              //   if (
              //     r.locseq.indexOf(vm.vrouter.AIRPORT) > 3 &&
              //     vm.displayRouteTypes.indexOf("DEP") >= 0
              //   )
              //     return true;
              // }
              // _log_("reject", r.destination);
              return false;
            }
          })
        );
    },
    async removeVehicle(data) {
      _log_("fss....", data);
      this.pause = true;
      await this.vrouter.updateRoute(
        { asset_id: null, transmean: null, execLog: null, ntf_update: null },
        data.id,
        true
      );
      this.vrouter.updateVehicleData();
      this.pause = false;
    },
    icon(t) {
      const icons = {
        mini: "shuttle-van",
        MINI: "shuttle-van",
        medium: "bus",
        MEDIUM: "bus",
        normal: "bus-alt",
        NORMAL: "bus-alt",
        big: "bus-alt",
        BIG: "bus-alt",
        double: "subway",
        DOUBLE: "subway",
        external: "taxi",
      };
      if (!icons[t]) {
        console.error("missing icon for ", t);
        return "bus";
      }
      return icons[t];
    },

    scrollLevelRoutes(level) {
      var options = {
        container: "#routesC",
        easing: "ease-in",
        offset: 0,
        force: true,
        // cancelable: true,
        onStart: function (element) {
          // scrolling started
        },
        onDone: function (element) {
          // scrolling is done
        },
        onCancel: function () {
          // scrolling has been interrupted
        },
        x: false,
        y: true,
      };
      var cc = document.getElementById("routesC");
      var archors = cc.getElementsByClassName(level); //querySelector(".level" + level)
      // var testA = document.querySelector(".level" + level+":first")
      // _log_("fss....", test);
      if (archors && archors.length && archors[0].id)
        var cancelScroll = this.$scrollTo("#" + archors[0].id, 300, options);
      // var cancelScroll = VueScrollTo.scrollTo(element, duration, options)

      // or alternatively inside your components you can use
      // var cancelScroll = this.$scrollTo(".level" + level, 300, options);
    },
    bestVehiclesCalced() {
      if (!this.vrouter) return [];
      // if (!this.selectedVehicle) return this.routes;
      var r = this.vrouter.bestVehicles(this.selectedRoute);
      //
      return r;
    },
    selectRoute(rr) {
      this.selectedRoute = null;
      this.selectedRoute = rr;
      // if (this.routesFirst)
      this.$nextTick(() => {
        this.$refs["chooseVehicle"].focus();
      });
      this.getLiveData(true);
    },
    focusRoutes(vid) {
      _log_("vid..", vid);
    },
    async assignRoute(data, vd) {
      const notf = this.$message({
        message: "Processing...",
        type: "warning",
      });
      await this.vrouter.updateRoute({ asset_id: vd }, data.rid, true);
      await this.vrouter.updateVehicleData();
      notf.close();
      //  ++this.clock;
      // alert(`add R: ${JSON.stringify(data)}`);
    },
    async assignVehicle(data, rt) {
      // const notf = this.$message({
      //   message: "Processing...route",
      //   type: "warning",
      // });
      this.$set(rt, "changing", true);
      // rt.changing = true;
      await this.vrouter.updateRoute(
        { asset_id: data.vid ? data.vid : data.id },
        rt.id,
        true
      );
      await this.vrouter.updateVehicleData();
      // notf.close();
      this.$set(rt, "changing", false);
      // this.loaded = true;
      //   ++this.clock;
    },
    async loadData() {
      this.selectDate = false;
      this.pause = true;
      this.loaded = false;
      this.processingRoutes = true;
      this.processingVehicles = true;

      if (!this.workingDate)
        this.workingDate = dateHelper.format(new Date(), this.dateFormat);
      var data = await api.fetchProcessor("route/getlistionian", {
        workingDate: this.workingDate,
        limit: 0,
        notincludecache: true,
        with: "execlog",
        plain: "visj",
        flatroutes: false,
        noCalcCosts: true,
        sort: "startTimeMM",
      });
      this.routes = data.data.results;
      _log_("sorted V.this.routes.", this.routes);
      this.vrouter.setRoutes(this.routes);
      var datav = await api.fetchProcessor("assets/getlistdetailed", {
        workingDate: this.workingDate,
        archiveLevel: [0],
        limit: 0,
      });

      this.vehicles = datav.data.results;

      this.vrouter.setVehicles(this.vehicles, true);
      this.processingRoutes = false;
      this.processingVehicles = false;
      this.loaded = true;
      this.pause = false;
    },
    async getLiveData(forceReload) {
      // _log_("CHECK.", this.selectedVehicle);
      if (
        forceReload ||
        (!this.selectedRoute.id && !this.selectedVehicle.id && !this.pause)
      ) {
        _log_("CHECK.", this.timeNow);
        var w = await api.fetchProcessor("waypoints/getfleet", {
          anotherDate:
            this.workingDate != this.timeNow ? this.workingDate : null,
        });

        if (w && w.data) this.vrouter.setLiveData(w.data);
      }
      _log_("GO REBUILD.best routs for", this.selectedVehicle);
      var rs = this.vrouter.bestRoutes(this.selectedVehicle, this.timePriority);
    },
  },
  async mounted() {
    const vm = this;

    var legs = await api.fetchProcessor("legs/getlist", {
      opta: true,
    });
    var locs = await api.fetchProcessor("locations/getlist", {
      limit: 0,
    });
    var contacts = await api.fetchProcessor("contacts/getlist", {
      limit: 0,
      contactTypes: "escort,driver",
    });
    this.vrouter = new RouterEngine(
      this,
      legs.data.results,
      locs.data.results,
      contacts.data.results
    );
    // this.vrouter.usedLocs=this.todayLocs

    this.vrouter.filters.routetypes = this.displayRouteTypes;
    this.loadData();

    setInterval(function () {
      vm.timeNow = vm.formatUnxTime("now", false, true);
      // ++vm.clock;
      // _log_("the rs///" + vm.clock, vm.timeNow);
    }, 1000);
    setInterval(function () {
      // ++vm.clock;
      vm.getLiveData();
      // _log_("the rs///", vm.getLiveData());
    }, 3000);
    this.emulator();
    this.loaded = true;
    this.pause = false;
    // _log_("the rs///", this.rooms);
  },
  computed: {
    selectedDriver() {
      const dr = this.selectedVehicle.drivers[0]
        ? this.vrouter.getContact(this.selectedVehicle.drivers[0])
        : null;
      return dr ? dr.name : null;
    },
    popVehiclesState() {
      if (!this.routesFirst) return "";

      if (this.selectedRoute.id) return "staticDisplay";
    },
    refreshSync() {
      return Math.floor(this.clock / 10);
    },
    ...mapGetters({
      rooms: "hotelinfo/rooms",
    }),
    bestRoutes() {
      _log_("R B..");
      this.processingRoutes = true;

      const vm = this;
      if (!this.vrouter) {
        this.processingRoutes = false;
        return [];
      }
      // apply filters
      if (this.focusOnVehicle)
        return this.routes.filter(function (r) {
          vm.processingRoutes = false;
          return r.asset_id == vm.focusOnVehicle;
        });

      this.processingRoutes = false;
      return this.vrouter.routeAssets;
    },
    bestVehicles() {
      this.processingVehicles = true;
      if (!this.vrouter) {
        this.processingVehicles = false;
        return [];
      }
      //  this.processingVehicles = false;
      // return this.vrouter.vehicleAssets;
      // if (!this.selectedVehicle) return this.routes;
      var r = this.vrouter.bestVehicles(this.selectedRoute);
      // _log_("sorted V..", r);
      this.processingVehicles = false;
      return r;
      // return r.filter(v => v.weight && v.weight.howBad);
    },
    badVehicles() {
      const vm = this;
      return this.bestVehicles
        ? this.bestVehicles.filter(
            (v) =>
              (v.active || vm.activationEnabled) &&
              (!v.weight || !v.weight.howBad)
          )
        : null;
    },
    airportSmallVehicles() {
      const vm = this;
      return this.bestVehicles
        ? this.bestVehicles.filter(
            (v) =>
              (v.active || vm.activationEnabled) &&
              v.capacity < 30 &&
              v.nowis &&
              v.nowis.locid + "" == vm.vrouter.AIRPORT + ""
          )
        : null;
    },
    airportBigVehicles() {
      const vm = this;
      return this.bestVehicles
        ? this.bestVehicles.filter(
            (v) =>
              (v.active || vm.activationEnabled) &&
              v.capacity >= 30 &&
              v.nowis &&
              v.nowis.locid + "" == vm.vrouter.AIRPORT + ""
          )
        : null;
    },
    goodVehicles() {
      const vm = this;
      if (!this.bestVehicles) return null;
      if (!this.selectedRoute.id)
        return this.bestVehicles.filter(
          (v) =>
            (v.active || vm.activationEnabled) &&
            (!v.nowis || v.nowis.locid + "" != vm.vrouter.AIRPORT + "")
        );
      return this.bestVehicles.filter((v) => v.weight && v.weight.howBad);
    },
    pickerOptions() {
      var vm = this;
      return {
        shortcuts: [
          {
            text: "Σήμερα",
            onClick(picker) {
              const date = new Date();
              vm.bookingRangeR = [date.getTime(), date.getTime()];
            },
          },
          {
            text: "Αύριο",
            onClick(picker) {
              const date = new Date();
              vm.bookingRangeR = [
                date.getTime() + 3600 * 1000 * 24,
                date.getTime() + 3600 * 1000 * 24,
              ];
              // date.setTime();
              picker.$emit("pick", vm.bookingRangeR);
              //  date.setTime([date.getTime() + 3600 * 1000 * 24,date.getTime() + 3600 * 1000 * 24]);
              // picker.$emit("pick", date);
            },
          },
          {
            text: "7 μέρες",
            onClick(picker) {
              const date = new Date();
              vm.bookingRangeR = [
                date.getTime(),
                date.getTime() + 3600 * 1000 * 24 * 7,
              ];
              // date.setTime();
              picker.$emit("pick", vm.bookingRangeR); //[new Date(),(date.getTime() - 3600 * 1000 * 24 * 7)]);
            },
          },
          {
            text: "1 μήνα",
            onClick(picker) {
              const date = new Date();
              vm.bookingRangeR = [
                date.getTime(),
                date.getTime() + 3600 * 1000 * 24 * 31,
              ];
              // date.setTime();
              picker.$emit("pick", vm.bookingRangeR); //[new Date(),(date.getTime() - 3600 * 1000 * 24 * 7)]);
            },
          },
        ],
      };
    },
    colDefinitions() {
      var rw = "380px";
      if (window.innerWidth < 500) rw = "150px";
      if (window.innerWidth < 700) rw = "240px";
      if (window.innerWidth < 1000) rw = "300px";
      return [
        // {
        //   prop: "paymentStatus",
        //   width: "120px",
        //   label: "Πληρωμή",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-payment"
        //   }
        // },
        { prop: "refNum", width: "", label: "Αρ.Κρατησης" },
        { prop: "bookingDateF", width: "", label: "Ημερ.Κράτησης" },

        { prop: "firstName", width: "", label: "Ονομα" },

        {
          prop: "roomsF",
          width: rw,
          label: "Κράτηση",
          displayClass: "el-tag el-tag--info",
          component: {
            is: "v-rooms",
          },
        },
      ];
    },
  },
};
</script>

<style>
.staticDisplay {
  position: fixed;
  background-color: ghostwhite;
  z-index: 10;
}
.vehicle-slot {
  padding: 3px;
}
.vehicle-slot.rselected {
  box-shadow: 0px 0px 5px;
  border: 1px dotted blue;
}

.routing-slot {
  padding: 3px;
}
.routing-slot.rselected {
  box-shadow: 0px 0px 5px;
  border: 1px dotted blue;
}

.flip-list-move {
  transition: transform 1s;
}

.search.x-row {
  align-items: flex-start;
}
.has-more {
  color: red;
  font-weight: 700;
}
.vstopped {
  background-color: goldenrod !important;
}
.selectedElement {
  color: black;
  padding: 2px;
  box-shadow: 0px 2px 4px gray;
  /* margin-bottom: 5px; */
  margin-left: 3px;
  background-color: #ffffff;
}
span.title {
  font-weight: bold;
  font-size: 11px;
}
span.info {
  color: grey;
  font-size: 9px;
}
div.active {
  height: 24px;
  padding-left: 3px;
  line-height: 1;
  margin-bottom: 2px;
  color: blue;
  background-color: aquamarine;
}
div.active span.title {
  color: blue;
}
div.freezed {
  height: 24px;
  line-height: 1;
  padding-left: 3px;
  margin-bottom: 2px;
  background-color: midnightblue;
  color: wheat;
}
div.freezed span.info {
  color: wheat;
}
.el-autocomplete-suggestion li {
  padding: 2px !important;
}
</style>
